<template>
  <li class="NodeSelector">
    <lm-checkbox
      class="NodeSelectorCheckbox pb-3"
      :label="actor.name"
      :color="actor.color"
      :disabled="isActive"
      :value="isSelected || isActive"
      @change="isSelected = $event && !isActive"
    />
    <ul v-if="actor.actors" class="ml-6">
      <node-selector
        v-for="child in actor.actors"
        :key="child._id"
        v-model="selectedActors"
        :actor="child"
        :is-active="isSelected || isActive"
      />
    </ul>
  </li>
</template>

<script>
import LmCheckbox from '@/components/form/LmCheckbox'
export default {
  name: 'NodeSelector',
  components: {LmCheckbox},
  model: {
    prop: 'selectedActors'
  },
  props: {
    selectedActors: {
      // v-model
      type: Array,
      required: true
    },
    actor: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isSelected: {
      get() {
        return this.selectedActors.includes(this.actor._id)
      },
      set(selected) {
        const index = this.selectedActors.findIndex(id => this.actor._id === id)
        if (selected) {
          if (index < 0) this.selectedActors.push(this.actor._id)
        } else {
          if (index >= 0) this.selectedActors.splice(index, 1)
        }
      }
    }
  },
  watch: {
    isActive(newValue) {
      if (!newValue && this.isSelected) {
        this.isSelected = false
      }
    }
  }
}
</script>
